// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Oups_content__T4Zye {
  text-align: center;
}

.Oups_link__Xu\\+eV {
  margin-top: 20px;
}
.Oups_link__Xu\\+eV p {
  color: #0000c9 !important;
}

.Oups_mail__31\\+G4 {
  text-decoration: underline;
  cursor: pointer;
}
.Oups_mail__31\\+G4 svg {
  vertical-align: middle;
  margin-bottom: 3px;
  margin-left: 2px;
}`, "",{"version":3,"sources":["webpack://./src/components/RCPro/pages/Oups/Oups.module.scss"],"names":[],"mappings":"AAEA;EACI,kBAAA;AAKJ;;AAFA;EACI,gBAAA;AAKJ;AAJI;EACI,yBAAA;AAMR;;AAFA;EACI,0BAAA;EACA,eAAA;AAKJ;AAHI;EACI,sBAAA;EACA,kBAAA;EACA,gBAAA;AAKR","sourcesContent":["@use 'styles/colors.scss';\n\n.content{\n    text-align: center;\n}\n\n.link{\n    margin-top: 20px;\n    p{\n        color: colors.$primary6 !important;\n    }\n}\n\n.mail{\n    text-decoration: underline;\n    cursor: pointer;\n\n    svg{\n        vertical-align: middle;\n        margin-bottom: 3px;\n        margin-left: 2px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colabelNeutralLight": `#F9F9FA`,
	"colabelNeutralMid": `#C3C3C9`,
	"colabelNeutralDark": `#121217`,
	"content": `Oups_content__T4Zye`,
	"link": `Oups_link__Xu+eV`,
	"mail": `Oups_mail__31+G4`
};
export default ___CSS_LOADER_EXPORT___;
